import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'


export function getTopiclList (query) {  //话题列表 
    return fetchGet('/gateway/v1/house-topics', query)
}

export function getBanklList (query) {  //话题库列表
    return fetchGet('/gateway/v1/house-topic-banks', query)
}
export function getBankDetail(id) { //话题详情
    return fetchGet('/gateway/v1/house-topic-banks/'+id)
}
export function deleteBankItem (id) { //删除话题
    return fetchDelete('/gateway/v1/house-topic-banks/'+id)
}
export function ediBankItem (id,query) { //编辑话题
    return fetchPut('/gateway/v1/house-topic-banks/'+id,query)
}
export function bankItemAdd (query) { //话题添加
    return fetchPost('/gateway/v1/house-topic-banks',query)
}


export function getAnswerlList (query) {  //楼盘话题回答列表
    return fetchGet('/gateway/v1/house-topic-ask-answers', query)
}
export function deleteBatchAnswer (query) { //批量删除楼盘话题回答
    return fetchDelete('/gateway/v1/house-topic-ask-answers',query)
}
export function editAnswerContent (id,query) { //编辑回答内容 ------------------------
    return fetchPut('/gateway/v1/house-topic-ask-answers/'+id+'/content',query)
}
export function conformBatchAnswer (query) { //批量审核话题
    return fetchPut('/gateway/v1/house-topic-ask-answers/status',query)
}


export function getAskList (query) {  //楼盘话题审核列表
    return fetchGet('/gateway/v1/house-topic-asks/audits', query)
}
export function getAskDetail (id) {  //楼盘话题审核详情
    return fetchGet('/gateway/v1/house-topic-asks/'+id)
}
export function deleteBatchAsk (query) { //批量删除楼盘话题
    return fetchDelete('/gateway/v1/house-topic-asks',query)
}
export function conformBatchAsk (query) { //批量审核话题
    return fetchPut('/gateway/v1/house-update-asks/status',query)
}
export function editAskContent (id,query) { //编辑话题内容
    return fetchPut('/gateway/v1/house-topic-asks/'+id,query)
}

export function getTopicModelList (query) {  //话题建模列表
    return fetchGet('/gateway/v1/house-topic-model-records', query)
}
export function getTopicAnsRecord (query) {  //查看生回答成记录
    return fetchGet('/gateway/v1/house-topic-model-record-answers', query)
}
export function getTopicAskwerRecord (query) {  //查看问题生成记录
    return fetchGet('/gateway/v1/house-topic-model-record-asks', query)
}
export function addTopicTask (query) { //新增建模任务
    return fetchPost('/gateway/v1/house-topic-model-records',query)
}
export function addTopicTaskByHouse (query) { //按楼盘新增建模任务
    return fetchPost('/gateway/v1/house-topic-model-records/by-house',query,{
        'Content-Type': 'multipart/form-data'
    })
}
export function terminationTask (query) { //终止任务
    return fetchPut('/gateway/v1/house-topic-model-records/terminated',query)
}
export function topicAssigned (query) { //随机分配话题
    return fetchPost('/gateway/v1/house-topic-banks/assigned',query)
}
export function singleAsksList(query) { //问答题库单个问题列表
    return fetchGet('/gateway/v1/house-topic-model-single-asks',query)
}
export function addSingleAsks(query) { //创建问答题库单个问题
    return fetchPost('/gateway/v1/house-topic-model-single-asks',query)
}
export function singleAsksDetail(id) { //问答题库单个问题详情
    return fetchGet('/gateway/v1/house-topic-model-single-asks/'+id)
}
export function editSingleAsks (id,query) { //修改问答题库单个问题
    return fetchPut('/gateway/v1/house-topic-model-single-asks/'+id,query)
}
export function deleteSingleAsks (id) { //删除问答题库单个问题
    return fetchDelete('/gateway/v1/house-topic-model-single-asks/'+id)
}

export function assembleAsksList(query) { //问答题库多个问题列表
    return fetchGet('/gateway/v1/house-topic-model-assemble-asks',query)
}
export function addAssembleAsks(query) { //创建问答题库多个问题
    return fetchPost('/gateway/v1/house-topic-model-assemble-asks',query)
}
export function assembleAsksDetail(id) { //问答题库多个问题详情
    return fetchGet('/gateway/v1/house-topic-model-assemble-asks/'+id)
}
export function editAssembleAsks (id,query) { //修改问答题库多个问题
    return fetchPut('/gateway/v1/house-topic-model-assemble-asks/'+id,query)
}
export function deleteAssembleAsks (id) { //删除问答题库多个问题
    return fetchDelete('/gateway/v1/house-topic-model-assemble-asks/'+id)
}
export function creatRecordPreviews(query) { //话题建模预览创建
    return fetchPost('/gateway/v1/house-topic-model-record-previews',query)
}
export function creatRecordPreviewsByHouse(query) { //按楼盘话题建模预览创建
    return fetchPost('/gateway/v1/house-topic-model-record-previews/by-house',query,{
        'Content-Type': 'multipart/form-data'
    })}
export function getRecordPreList(query) { //话题建模预览列表
    return fetchGet('/gateway/v1/house-topic-model-record-previews',query)
}
export function recordPreviewsDetail(id) { //话题建模预览详情
    return fetchGet('/gateway/v1/house-topic-model-record-previews/'+id)
}
export function deleteRecordPreviews (id) { //话题建模预览删除
    return fetchDelete('/gateway/v1/house-topic-model-record-previews/'+id)
}




